/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function GitlabLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M238.28027,152.50246,210.95068,50.01662a12.00021,12.00021,0,0,0-22.83056-1.12109L167.45605,104H88.544L67.87988,48.89651a12.00012,12.00012,0,0,0-22.831,1.12109L17.71973,152.50246a16.03981,16.03981,0,0,0,6.35254,17.27783l94.82031,65.64454a15.91589,15.91589,0,0,0,7.093,2.69336c.22131.03808.44567.05517.67065.0747.09387.00781.1875.01514.28149.02149.13526.00683.26807.03076.40406.03076.06445,0,.12939-.00733.19409-.00879.15478.00439.30932.01709.46411.01709s.30933-.0127.46411-.01709c.0647.00146.12964.00879.19409.00879.13587,0,.26831-.02393.40345-.03076q.1419-.00952.2832-.02149c.22436-.02.44812-.03662.66882-.0747a15.91868,15.91868,0,0,0,7.09375-2.69336l94.82031-65.64454A16.03981,16.03981,0,0,0,238.28027,152.50246ZM33.17969,156.625,42.94617,120H77.45605l34.07544,90.86865Zm111.28882,54.24365L178.544,120h34.50988l9.76648,36.625Z" />
    </Svg>
  );
}

export default GitlabLogo;
